import React, { useState, useEffect } from "react";
import { Grid, Divider } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import CircularProgress from "@material-ui/core/CircularProgress";
import { useSelector } from "react-redux";
import { getRUCEmpresa } from "redux/actions/userActions";
//componentes del sistema
import TablePaginated from "widgets/Tables/TablePaginated";
import TableSimple from "widgets/Tables/TableSimple";
import { API_GET_ALL_COMPANIES, API_GET_SEARCH_COMPANIES } from "./apis";
import clientBackend from "configurations/axios";
import tableStyle from "configurations/styles/table";
import SearchCompany from "./Froms/SearchCompany";
import EditSubscriptionKey from "./Buttons/EditSubscriptionKey";
import { CardGeneric } from "../components/CardGeneric";
import { Button } from "@mui/material";
import UploadRoundedIcon from '@mui/icons-material/UploadRounded';
import TablePaginatedPay from "widgets/Tables/TablePaginatedPay";

const useStyles = makeStyles((theme) => ({
  root: {
    paddingTop: "35px",
    paddingBottom: "7%",
    flexGrow: 1,
    paddingLeft: "3%",
    paddingRight: "3%",
  },
  headerBottons: {
    padding: "0.5%",
  },
  loader: {
    display: "flex",
    justifyContent: "center",
    alignContent: "center",
    alignItems: "center",
    height: "300px"
  }
}));

const Home = () => {
  const tokenUser = useSelector((state) => state.user.tk);

  const classesView = useStyles();
  const [update, setUpdate] = useState(0);
  const [foundCompanies, setFoundCompanies] = useState([]);
  const [paramSearch, setParamSearch] = useState("");
  const columns = [
    {
      title: "RUC",
      field: "idEmpresa",
      cellStyle: tableStyle.cellTable,
      width: "8%",
    },
    {
      title: "Razón Social",
      field: "razonSocialempresa",
      cellStyle: tableStyle.cellLeft,
      width: "25%",
    },
    {
      title: "Clave Suscripción",
      field: "subscriptionKey",
      cellStyle: tableStyle.cellLeft,
      width: "25%",
    },
    {
      title: "Editar",
      cellStyle: tableStyle.cellTable,
      width: "3%",
      render: (rowData) => (
        <EditSubscriptionKey company={rowData} updateView={reload} />
      ),
    },
  ];

  const getParam = (data) => {
    setParamSearch(data);
    if (data.length > 0) {
      searchCostumer(data);
    } else {
      reload();
    }
  };

  const searchCostumer = async (param) => {
    setUpdate(3);
    await clientBackend
      .get(
        API_GET_SEARCH_COMPANIES +
        "?parametroBusqueda=" +
        param
      )
      .then((response) => {
        if (response.status === 200) {
          setFoundCompanies(response.data);
          setUpdate(2);
        }
      })
      .catch((exception) => {
        console.error({ exception });
      });
  };


  const requestConfig = {
    uri: API_GET_ALL_COMPANIES,
    metodo: "get",
    body: null,
    page: 0,
    elementos: 15,
    sort: "idEmpresa,desc",
  };

  const reload = () => {
    setUpdate(1);
  };

  useEffect(() => {
    if (update === 1) {
      setUpdate(0);
    }
  }, [update]);


  const renderTable = () => {
    switch (update) {
      case 0:
        return (
          <TablePaginated
            title=""
            columns={columns}
            requestConfig={requestConfig}
          />
        );

      case 1:
      case 3:
        return (
          <div className={classesView.loader}>
            <CircularProgress />
          </div>
        );
      case 2:
        return (
          <TableSimple
            columns={columns}
            data={foundCompanies}
            title=""
            numberRowsPerPage={15}
          />
        );
      default:
        break;
    }
  };

  return (
    <div className={classesView.root}>
      <CardGeneric>
        <Grid container spacing={1}>
          <Grid item xs={12} md={9} className={classesView.headerBottons}>
            <SearchCompany backupParam={paramSearch} sendData={getParam} />
          </Grid>
        </Grid>
      </CardGeneric>
      {renderTable()}
    </div>
  );
};

export default Home;
